import * as actionTypes from '../../actionTypes';

export const showExtraModalAction = (params) => {
    return {
        type: actionTypes.SHOW_MODAL_EXTRA,
        payload : params
    }
}

export const hideExtraModalAction = (params) => {
    return {
        type: actionTypes.HIDE_MODAL_EXTRA,
        payload : params
    }
}